import React from 'react'

function Extra() {
  return (
    <div className='md:w-7/12 sm:w-3/4 mx-auto'>
        <h2 className='text-[#607744] tracking-widest font-semibold py-4 w-1/3 lg:text-4xl lg:leading-loose md:text-3xl md:w-fit md:leading-loose sm:text-2xl sm:w-fit sm:leading-loose'>
            一些小Tips
        </h2>
        {/* <div className='w-full grid lg:grid-cols-2 sm:grid-cols-1 justify-between gap-8'> */}
        <div className='w-full flex justify-between sm:flex-col lg:flex-row'>
            <div className='lg:w-2/5 sm:w-full min-h-fit'>
                <h4 className='font-bold text-base mb-2 text-[#34623F] lg:my-4'>
                    技能加分项
                </h4>
                <p className="text-[#1E2F23] md:text-sm sm:text-xs/8 sm:tracking-custom sm:leading-loose my-4 sm:h-fit lg:h-52 font-semibold py-6 break-all">
                    本科学过图形学或者
                    <span className="text-red-500">对图形学有浓厚兴趣</span>
                    ，强烈想要从事图形学相关的研究方向；学过C/C++/Python；已通过英语六级；具有较好的编程水平；
                    参加过ICPC竞赛并获奖的同学加分；具有团队协作精神、乐于交流分享、自我驱动力强的同学加分。
                </p>

            </div>
            <div className='lg:w-2/5 sm:w-full'>
                <h4 className='font-bold text-base mb-2 text-[#34623F] lg:my-4'>
                研究生工作日常
                </h4>
                <p className="text-[#1E2F23] md:text-sm sm:text-xs/8 sm:tracking-custom sm:leading-loose my-4 sm:h-fit lg:h-52 font-semibold py-6 break-all">
                    保证日常8小时出勤即可,
                    <span className="text-red-500">不打卡，不push！但需要在研究生就读期间以第一作者发表SCI论文一篇!</span>
                    周例会每周会有一次，主题是一周的工作内容及遇到的问题,工作内容可以是阅读论文心得、实验进展、论文进展等等。没有负担，周例会的目的不是完成任务，而是沟通、讨论、解决问题。
                </p>
            </div>
        </div>
    </div>
  )
}

export default Extra
